import React from 'react';
import { Instagram, Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

// Custom TikTok icon component
function TikTokIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
  );
}

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">{t.footer.about.title}</h3>
            <p className="text-gray-400 text-sm md:text-base">
              {t.footer.about.description}
            </p>
          </div>
          
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">{t.footer.contact.title}</h3>
            <div className="space-y-3">
              <a 
                href="tel:+97150190989" 
                className="flex items-center justify-center md:justify-start text-gray-400 hover:text-white"
              >
                <Phone className="h-5 w-5 mr-2 flex-shrink-0" />
                <span className="text-sm md:text-base">+971 50 190 9897</span>
              </a>
              <a 
                href="mailto:contact@sollbridge.com" 
                className="flex items-center justify-center md:justify-start text-gray-400 hover:text-white"
              >
                <Mail className="h-5 w-5 mr-2 flex-shrink-0" />
                <span className="text-sm md:text-base">contact@sollbridge.com</span>
              </a>
              <div className="flex items-center justify-center md:justify-start text-gray-400">
                <MapPin className="h-5 w-5 mr-2 flex-shrink-0" />
                <span className="text-sm md:text-base">{t.footer.contact.location}</span>
              </div>
            </div>
          </div>
          
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">{t.footer.social.title}</h3>
            <div className="flex justify-center md:justify-start space-x-6">
              <a
                href="https://www.instagram.com/sollbridge/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                title="Instagram"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a
                href="https://www.tiktok.com/@sollbridge"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                title="TikTok"
              >
                <TikTokIcon className="h-6 w-6" />
              </a>
              <a
                href="https://api.whatsapp.com/send/?phone=971503274455&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                title="WhatsApp"
              >
                <MessageCircle className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800">
          <p className="text-center text-sm text-gray-400">
            © {new Date().getFullYear()} SollBridge. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}